<template>
  <div class="tooltip-trigger" @mouseenter="show" @mouseleave="hide" ref="trigger">
    <slot />
  </div>

  <Teleport to="body">
    <Transition name="tooltip-fade">
      <div v-if="isVisible" class="tooltip" :style="tooltipStyle" ref="tooltip">
        <div class="tooltip-content">
          {{ text }}
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
export default {
  name: 'TooltipComponent',
  props: {
    text: {
      type: String,
      required: true
    },
    position: {
      type: String,
      default: 'top',
      validator: (value) => ['top', 'bottom', 'left', 'right'].includes(value)
    }
  },
  data() {
    return {
      isVisible: false,
      tooltipStyle: {}
    };
  },
  methods: {
    show() {
      this.isVisible = true;
      this.$nextTick(() => {
        this.updatePosition();
      });
    },
    hide() {
      this.isVisible = false;
    },
    updatePosition() {
      if (!this.$refs.trigger || !this.$refs.tooltip) return;

      const triggerRect = this.$refs.trigger.getBoundingClientRect();
      const tooltipEl = this.$refs.tooltip;
      const tooltipRect = tooltipEl.getBoundingClientRect();

      let top = 0;
      let left = 0;

      switch (this.position) {
        case 'top':
          top = triggerRect.top - tooltipRect.height - 8;
          left = triggerRect.left + (triggerRect.width / 2) - (tooltipRect.width / 2);
          break;
        case 'bottom':
          top = triggerRect.bottom + 8;
          left = triggerRect.left + (triggerRect.width / 2) - (tooltipRect.width / 2);
          break;
        case 'left':
          top = triggerRect.top + (triggerRect.height / 2) - (tooltipRect.height / 2);
          left = triggerRect.left - tooltipRect.width - 8;
          break;
        case 'right':
          top = triggerRect.top + (triggerRect.height / 2) - (tooltipRect.height / 2);
          left = triggerRect.right + 8;
          break;
      }

      // Keep tooltip within viewport
      const padding = 8;
      if (left < padding) left = padding;
      if (left + tooltipRect.width > window.innerWidth - padding) {
        left = window.innerWidth - tooltipRect.width - padding;
      }
      if (top < padding) top = padding;
      if (top + tooltipRect.height > window.innerHeight - padding) {
        top = window.innerHeight - tooltipRect.height - padding;
      }

      this.tooltipStyle = {
        top: `${top}px`,
        left: `${left}px`
      };
    }
  }
}
</script>

<style scoped>
.tooltip-trigger {
  display: inline-flex;
  align-items: center;
}

.tooltip {
  position: fixed;
  z-index: 10000;
  pointer-events: none;
}

.tooltip-content {
  background-color: #1f2937;
  color: #fff;
  padding: 6px 12px;
  border-radius: var(--border-radius);
  font-size: 13px;
  line-height: 1.4;
  max-width: 250px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  word-wrap: break-word;
  white-space: pre-line;
}

/* Fade animation */
.tooltip-fade-enter-active,
.tooltip-fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.tooltip-fade-enter-from {
  opacity: 0;
  transform: translateY(-4px);
}

.tooltip-fade-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

.tooltip-fade-enter-to {
  opacity: 1;
  transform: translateY(0);
}
</style>
